"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCommitmentPreview = exports.postPayment = exports.getPendingPayments = exports.getPaymentHistories = exports.getCommitments = exports.postCommitment = void 0;
const helpers_1 = require("../helpers");
const postCommitment = (serverURL, appAxios) => async commitment => await appAxios.post(`${serverURL}/commitments-v2`, commitment, {
  withCredentials: true
});
exports.postCommitment = postCommitment;
const getCommitments = (serverURL, appAxios) => async data => {
  const commitmentUrl = `${serverURL}/commitments-v2`;
  const dealCommitmentUrl = `${commitmentUrl}?dealId=${data?.dealId}`;
  const url = data?.dealId ? dealCommitmentUrl : commitmentUrl;
  return await appAxios.get(url, {
    withCredentials: true
  });
};
exports.getCommitments = getCommitments;
const getPaymentHistories = (serverURL, appAxios) => async paymentId => await appAxios.get(`${serverURL}/commitments-v2/payments/${paymentId}/timeline`, {
  withCredentials: true
});
exports.getPaymentHistories = getPaymentHistories;
/**
 * Retrieves pending payments for commitments.
 *
 * Business Logic:
 * 1. Returns the most overdue one-off payment, if any for a given commitment.
 * 2. Returns the next upcoming instalment payment, if any for a given commitment.
 * 3. Only includes payments where the underlying deal has either status: LIVE_ALL or CLOSED.
 * 4. Maximum of two payments can be returned (one one-off and one instalment) for a given commitment.
 * 5. Payments are sorted by due date in ascending order.
 * @returns An array of CommitmentPendingPayment objects.
 */
const getPendingPayments = (serverURL, appAxios) => async () => await appAxios.get(`${serverURL}/commitments-v2/pending-payments`, {
  withCredentials: true
});
exports.getPendingPayments = getPendingPayments;
const postPayment = (serverURL, appAxios) => async _ref => {
  let {
    commitmentId,
    paymentInput
  } = _ref;
  return await appAxios.post(`${serverURL}/commitments-v2/${commitmentId}/payments`, paymentInput, {
    withCredentials: true
  });
};
exports.postPayment = postPayment;
const getCommitmentPreview = (serverURL, appAxios) => async _ref2 => {
  let {
    commitmentId,
    amount,
    instalmentPlan
  } = _ref2;
  const previewUrl = `${serverURL}/commitments-v2/${commitmentId}/preview`;
  const withPlanUrl = `${previewUrl}?instalmentPlanAmount=${amount}&instalmentPlan=${instalmentPlan}`;
  const withoutPlanUrl = `${previewUrl}?oneOffAmount=${amount}`;
  const url = instalmentPlan ? withPlanUrl : withoutPlanUrl;
  const response = await appAxios.get(url, {
    withCredentials: true
  });
  const {
    data
  } = response;
  const commitment = new helpers_1.UserCommitment({
    commitment: data
  });
  return {
    commitmentId,
    amount: data.instalmentPlanAmount || 0,
    ...(instalmentPlan && {
      instalmentPlanBreakdown: {
        [instalmentPlan]: commitment.instalmentBreakdown
      }
    }),
    ...(data.error ? {
      errorMessage: data.error.message
    } : {})
  };
};
exports.getCommitmentPreview = getCommitmentPreview;